import { Component, OnInit } from "@angular/core";
import { TreeviewItem, TreeviewConfig } from "ngx-treeview";
import { Router } from "@angular/router";
import { RestService } from "../rest.service";
import { catchError, retry } from "rxjs/operators";
import { SystemUtils } from "../utils/system.utils";

@Component({
  selector: "app-environments",
  templateUrl: "./environments.component.html",
  styleUrls: ["./environments.component.css"],
})
export class EnvironmentsComponent implements OnInit {
  dropdownEnabled = true;
  items: TreeviewItem[];
  values: number[];
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 400,
  });

  isFailure: boolean = false;
  failureMessage: any = "";
  isSuccess: boolean = false;
  successMessage: any = "";
  environmentList: any = [];
  lists: any = [];
  systemList: any = [];
  isClick: boolean = false;
  isLoading: boolean = false;
  isSuperUser: any = "";

  constructor(private _restService: RestService, private router: Router) {}

  ngOnInit() {
    this.isSuperUser = localStorage.getItem("isSuper");

    this._restService
      .environmentList()
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.environmentList = f.EnvList),
          console.log("Ename ---->", this.environmentList)
        )
      );
  }

  categoryName(cid: any, v: any) {
    let p: any = this.lists;
    p.map((f: any) =>
      f.categoryId === cid ? (f.Visible === v ? (f.Visible = !v) : "") : ""
    );
    this.environmentList = p;
    console.log("P", p);
  }

  categoryId(id: any) {
    //alert(id);
  }

  categoryVisible(v: any) {
    //alert(v);
  }

  levelOneEvent(id: any, refId: any, etype: any) {
    let environmentList = this.environmentList;
    environmentList.map((f: any) =>
      f.id === id ? (f.Visible = !f.Visible) : (f.Visible = false)
    );
    this.environmentList = environmentList;
    this.isLoading = true;
    this.isSuperUser === "1"
      ? this.getsystemAccess(id, etype)
      : this.getsystemAccess(refId, etype);
  }

  getsystemAccess(id: any, etype: any) {
    this._restService
      .getsystemAccess(id, etype)
      .pipe(
        catchError((e) => {
          (this.isFailure = true), (this.failureMessage = e.error.StatusInfo);
          console.log("Onload Error --->", e.error);
          return e;
        })
      )
      .subscribe(
        (f: any) => (
          (this.systemList = f.systemAccess),
          SystemUtils.sortSystemAccess(this.systemList),
          console.log("SA", this.systemList),
          (this.isLoading = false)
        )
      );
  }

  levelTwoEvent(id: any) {
    let list = this.systemList;
    list.map((f: any) => (f.categoryId === id ? (f.Visible = !f.Visible) : ""));
    this.systemList = list;
  }

  collapseEvent(c1: any) {
    let list = this.systemList;
    list.map((a: any) =>
      a.hasOwnProperty("children")
        ? a.children.map((b: any) =>
            b.categoryId === c1
              ? (b.Visible = !b.Visible)
              : b.hasOwnProperty("children")
              ? b.children.map((c: any) =>
                  c.categoryId === c1
                    ? (c.Visible = !c.Visible)
                    : c.hasOwnProperty("children")
                    ? c.children.map((d: any) =>
                        d.categoryId === c1
                          ? (d.Visible = !d.Visible)
                          : d.hasOwnProperty("children")
                          ? d.children.map((f: any) =>
                              f.categoryId === c1
                                ? (f.Visible = !f.Visible)
                                : f.hasOwnProperty("children")
                                ? f.children.map((g: any) =>
                                    g.categoryId === c1
                                      ? (g.Visible = !g.Visible)
                                      : g.hasOwnProperty("children")
                                      ? g.children.map((h: any) =>
                                          h.categoryId === c1
                                            ? (h.Visible = !h.Visible)
                                            : h.hasOwnProperty("children")
                                            ? h.children.map((j: any) =>
                                                j.categoryId === c1
                                                  ? (j.Visible = !j.Visible)
                                                  : j.hasOwnProperty("children")
                                                  ? j.children.map((k: any) =>
                                                      k.categoryId === c1
                                                        ? (k.Visible = !k.Visible)
                                                        : ""
                                                    )
                                                  : ""
                                              )
                                            : ""
                                        )
                                      : ""
                                  )
                                : ""
                            )
                          : ""
                      )
                    : ""
                )
              : ""
          )
        : ""
    );
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.failureMessage === "Session Expired"
      ? (localStorage.clear(),
        (this.failureMessage = ""),
        this.router.navigate([""]))
      : (this.failureMessage = "");
  }

  confirmSuccessMessage() {
    this.isSuccess = false;
    this.successMessage = "";
  }
}
